'use client';

import { motion } from 'framer-motion';

const NODES = [
  { label: 'Client Dashboard', desc: 'Place & track orders', icon: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v4H4V5zm0 6h16v8a1 1 0 01-1 1H5a1 1 0 01-1-1v-8z' },
  { label: 'Smart Upload', desc: 'Auto HDR grouping', icon: 'M7 16a4 4 0 01-.88-7.9A5 5 0 1115.9 6 5 5 0 0117 15.9M12 12v9m0-9l-3 3m3-3l3 3' },
  { label: 'Admin', desc: 'Assign & monitor', icon: 'M9 17v-6h13M9 17H4V5a1 1 0 011-1h3m1 13V4m0 0h4M9 8h11' },
  { label: 'Editor Workspace', desc: 'Professional editing', icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.4-9.4a2 2 0 112.8 2.8L11.8 15H9v-2.8l8.6-8.6z' },
  { label: 'Secure Delivery', desc: 'Download & approve', icon: 'M12 15v3m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z' },
];

export default function PlatformSection() {
  return (
    <section className="relative py-16 lg:py-20 bg-[#0B0F1A] overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-sm font-semibold text-purple-400 mb-3 uppercase tracking-wider">The Shashio platform</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.1] mb-4">
            An end-to-end editing ecosystem
          </h2>
          <p className="text-lg text-gray-400 leading-relaxed">
            Every role connected in one platform — so nothing gets lost between upload and delivery.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-stretch justify-center gap-4">
          {NODES.map((node, i) => (
            <div key={node.label} className="flex flex-col lg:flex-row items-center gap-4 flex-1">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.1 }}
                whileHover={{ y: -4 }}
                className="w-full rounded-2xl border border-white/[0.08] bg-[#13151F]/70 p-6 text-center hover:border-purple-500/30 transition-colors"
              >
                <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-purple-500/25 to-blue-500/10 border border-purple-500/20 flex items-center justify-center text-purple-200 mb-3">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d={node.icon} />
                  </svg>
                </div>
                <h3 className="text-sm font-bold text-white">{node.label}</h3>
                <p className="text-xs text-gray-500 mt-0.5">{node.desc}</p>
              </motion.div>

              {i < NODES.length - 1 && (
                <svg className="w-5 h-5 text-purple-500/40 rotate-90 lg:rotate-0 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
